<template>
  <div>
    <v-fade-transition>
      <med-filters-more
        :canShowFilters="resultsFound && !showPopular"
        :metadata="metadata"
        :searchTitle="searchTitle"
        :categoryInfo="categoryInfo"
        :showPopular="showPopular"
        @updateFilters="filters = $event"
        @hasHash="showFilters = true"
        @viewType="viewType = $event"
      ></med-filters-more>
    </v-fade-transition>

    <v-fade-transition>
      <meds-results
        v-if="results"
        :results="results"
        :filters="filters"
        :showTable="viewType == 1"
        :metadata="metadata"
        :searchTitle="searchTitle"
        @resultCount="resultCount = $event"
      ></meds-results>
    </v-fade-transition>

    <v-fade-transition>
      <div
        v-if="!loading && resultCount && !resultCount.filteredIn"
        class="ma-6 pa-6 text-h6 yellow lighten-4 gray--text d-inline-block"
      >
        There are no results meeting your search and filtering requirements
      </div>
      <v-alert
        type="warning"
        v-else-if="!loading && results && !results.length"
      >
        No Results Found
      </v-alert>
    </v-fade-transition>
    <v-fade-transition>
      <div v-if="loading">
        <v-skeleton-loader
          v-for="n in 9"
          :key="n"
          :loading="true"
          class="d-inline-block mx-3 skeleton"
          type="card"
          :width="$vuetify.breakpoint.mdAndUp ? '400' : '100%'"
        ></v-skeleton-loader>
      </div>
    </v-fade-transition>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";
import ApiServices from "@/services/ApiServices";
import MedCategories from "@/assets/js/meds/MedCategories";

export default {
  name: "MedsHome",
  components: {
    MedsResults: () =>
      import(
        /* webpackPrefetch: true */ "@/components/medStuff/MedsResults.vue"
      ),

    MedFiltersMore: () =>
      import(
        /* webpackPrefetch: true */ "@/components/medStuff/MedFiltersMore.vue"
      ),
  },
  //mixins: [WatcherMixin],
  data: () => ({
    viewType: null,
    searchTerm: null,
    mode: "home",
    searchTitle: null,
    results: null,
    loading: false,
    filters: null,

    metadata: null,
    resultCount: null,
    categoryInfo: null, // populated if api returns category info metadata, used to show more details dialog
    showPopular: false, // show popular meds if nothing else is being shown
  }),
  computed: {
    resultsFound: function () {
      let r = this.results;
      if (!r) return false;
      return r.length;
    },

    moreInfo: function () {
      return null;
    },
    pageTitle: function () {
      let prefix = "EyeDock/Meds ";
      let title = "";
      if (this.searchTitle) {
        // capitalize it
        let suffix =
          this.searchTitle[0].toUpperCase() +
          this.searchTitle.slice(1).toLowerCase();
        title = "| " + suffix;
      }
      return prefix + title;
    },
  },
  methods: {
    // apiRoute is a string referencing a function name from ApiServices.js
    doSearch(apiRoute, q, title = null) {
      this.loading = true;
      this.categoryInfo = false;

      ApiServices.genericApiCall(apiRoute + encodeURIComponent(q))
        .then((response) => {
          this.results = response.data.meds;
          if (title) {
            this.searchTitle = title;
          } else {
            if (response.data?.meta?.title)
              this.searchTitle = response.data.meta.title;
          }
          if (response.data?.meta?.info?.categories)
            this.categoryInfo = response.data.meta.info;
          if (response.data?.meta) this.metadata = response.data.meta;

          this.loading = false;

          // this.$store.dispatch("loading", false);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          // this.$store.dispatch("loading", false);
        });
    },

    abstractSearch(apiRoute, q, title) {
      //if (!q) return;
      this.loading = true;
      this.categoryInfo = false;

      ApiServices[apiRoute](q)
        .then((response) => {
          this.results = response.data.meds;
          if (title) {
            this.searchTitle = title;
          } else {
            if (response.data?.meta?.title)
              this.searchTitle = response.data.meta.title;
          }
          if (response.data?.meta?.info?.categories)
            this.categoryInfo = response.data.meta.info;
          if (response.data?.meta) this.metadata = response.data.meta;

          this.loading = false;

          // this.$store.dispatch("loading", false);
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          // this.$store.dispatch("loading", false);
        });
    },
    doDispatch(mode, detail) {
      this.$store.dispatch("setModeAndDetail", {
        mode: mode,
        detail: detail,
      });
    },
  },
  watch: {
    viewType(val) {
      this.$cookies.set("medDisplayType", val);
    },
  },
  mounted: function () {
    //let route = this.$router.currentRoute.path; // will be "/" if at root

    let searchTerm = this.$route.params.term;
    let category = this.$route.params.category;
    let ingredient_id = this.$route.params.ingredient_id;
    let moa_id = this.$route.params.moa_id;
    let category_id = this.$route.params.category_id;
    let company_id = this.$route.params.company_id;
    let rxcui = this.$route.params.rxcui;
    this.showPopular = false;

    let q = this.$route.query.q;
    if (q) searchTerm = decodeURIComponent(q);
    // if (searchTerm) searchTerm = decodeURIComponent(searchTerm);

    if (searchTerm) {
      this.searchTerm = searchTerm;
      this.doDispatch("name", searchTerm);
      this.doSearch("/meds/search/", searchTerm);
    } else if (category) {
      this.doDispatch("category", category);
      let title = MedCategories.titleForCategoryType(category);
      this.doSearch("/meds/category/", category, title);
    } else if (category_id) {
      this.doDispatch("categoryID", category_id);
      this.doSearch("/meds/categoryById/", category_id);
    } else if (company_id) {
      this.doDispatch("company", company_id);
      this.doSearch("/meds/companies/ndc/", company_id);
    } else if (ingredient_id) {
      this.doDispatch("ingredient", ingredient_id);
      this.doSearch("/meds/ingredient/", ingredient_id);
    } else if (moa_id) {
      this.doDispatch("moa", moa_id);
      this.doSearch("/meds/moa/", moa_id);
    } else if (rxcui) {
      this.doDispatch("rxcui", rxcui);
      this.doSearch("/meds/rxcui/", rxcui);
    } else {
      // just show the popular meds
      this.doDispatch("home", "popular");

      this.doSearch("/meds/popular", "");
      this.showPopular = true;
    }
  },

  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
};
</script>
<style scoped>
.fullWidth {
  width: 100%;
}

.textField {
  width: 200px;
}
.sidebar {
  max-width: 250px;
}
.typeButton {
  width: 150px;
}
.pointer {
  cursor: pointer;
}
.skeleton {
  width: 90%;
  margin: 20px auto;
}
.max300 {
  max-width: 300px;
}
/* .blueBorder {
  border: 1px solid #ddebf3 !important;
} */
</style>
